// removed by extract-text-webpack-plugin
module.exports = {"currentSchoolsList":"currentSchoolsList__2QR3l","currentSchoolsListItem":"currentSchoolsListItem__3MJEd"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/account/registrationFlow/style.scss
// module id = 390
// module chunks = 0